var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view queryInvoice" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _vm.isShow
            ? _c(
                "search-item",
                {
                  key: "tabInvoiceQuery_searchItem",
                  ref: "searchItem",
                  attrs: {
                    "show-more-scheme": true,
                    "show-simple": true,
                    "is-append-query": true,
                    "expand-adv": true,
                    "search-item-code": _vm.$t("Clearing.InvoiceInquiry"),
                    "config-module": "502",
                    "grid-config-module": "190605",
                    "custom-sim-query-placeholder": _vm.$t(
                      "Clearing.QuickSearchInvoiceNumber"
                    ),
                    "auto-init": true,
                    "custom-search-items": _vm.customSearchItems
                  },
                  on: {
                    advSearchItemCallBack: _vm.fetchData,
                    simSearchItemCallBack: _vm.fetchDataBykeyWord,
                    advToggle: _vm.scrollCallback,
                    perConfigChange: function(value) {
                      _vm.perConfigName = value
                    },
                    refreshGrid: function() {
                      _vm.gridRefreshId += 1
                    },
                    defaultSearchItemsChange: function(value) {
                      _vm.defaultSearchItems = value
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex" },
                      attrs: { slot: "operations" },
                      slot: "operations"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "1" },
                          on: {
                            click: function($event) {
                              return _vm.showInvoiceHandler(undefined, true)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.invoice_view")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_ACInvoice_approve"],
                              expression: "['button_ACInvoice_approve']"
                            }
                          ],
                          attrs: { type: "primary", no: "2" },
                          on: { click: _vm.approveHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.invoice_recheck")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_ACInvoice_approve"],
                              expression: "['button_ACInvoice_approve']"
                            }
                          ],
                          attrs: { type: "primary", no: "3" },
                          on: { click: _vm.unapproveHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Invoice.invoice_cancelRecheck"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_ACInvoice_forceDelete"],
                              expression: "['button_ACInvoice_forceDelete']"
                            }
                          ],
                          attrs: { type: "danger", no: "4" },
                          on: { click: _vm.forceDeleteHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.invoice_forceDelete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", no: "5" },
                          on: { click: _vm.deleteHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.invoice_delete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_ACInvoice_invalid"],
                              expression: "['button_ACInvoice_invalid']"
                            }
                          ],
                          attrs: { no: "6", type: "danger" },
                          on: { click: _vm.revokeHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.invoice_invalid")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (_vm.properties.enableCustomizeRevokeInvoice &&
                                  _vm.$checkPermission([
                                    "button_ACInvoice_redPunch"
                                  ])) ||
                                _vm.jinRongExchangeMode,
                              expression:
                                "(properties.enableCustomizeRevokeInvoice && $checkPermission(['button_ACInvoice_redPunch'])) || jinRongExchangeMode"
                            }
                          ],
                          attrs: { no: "7", type: "danger" },
                          on: { click: _vm.redPunchHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.invoice_redPunch")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_ACInvoice_exportInvoiceData"],
                              expression:
                                "['button_ACInvoice_exportInvoiceData']"
                            }
                          ],
                          attrs: { type: "primary", no: "9" },
                          on: { click: _vm.exportInvoiceDataHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_InvoiceExport")))]
                      ),
                      _c(
                        "cargo-el-upload",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_ACInvoice_importInvoiceNo"],
                              expression: "['button_ACInvoice_importInvoiceNo']"
                            }
                          ],
                          staticStyle: {
                            "padding-left": "5px",
                            "padding-right": "5px"
                          },
                          attrs: {
                            no: "importVATHandler",
                            action: "",
                            accept: ".xlsx, .xls",
                            "auto-upload": false,
                            "show-file-list": false,
                            "on-change": _vm.importInvoiceDataHandler
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "InvoiceNoImport" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_InvoiceNoImport"))
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      false
                        ? _c(
                            "el-button",
                            { attrs: { no: "10", type: "primary" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Invoice.invoice_importVATInvoice")
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_fmMakeInvoice_CATISExport"],
                              expression: "['button_fmMakeInvoice_CATISExport']"
                            }
                          ],
                          attrs: { no: "11", type: "primary" },
                          on: { click: _vm.interfaceExportBatchHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.invoice_CATISExport")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "12" },
                          on: { click: _vm.printHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.invoice_print")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "13" },
                          on: { click: _vm.toApplyPay }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Invoice.invoice_applyForPayment"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "14" },
                          on: { click: _vm.batchDownloadElectronicInvoice }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Invoice.invoice_BatchDownloadElectronicInvoice"
                              )
                            )
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.properties.interfaceNameEI ===
                                  _vm.InvoiceConstant.INVOICE_YSHS &&
                                _vm.properties.interfaceName ===
                                  _vm.InvoiceConstant.INVOICE_YSHS &&
                                _vm.$checkPermission([
                                  "button_ACInvoice_getInvoiceNo"
                                ]),
                              expression:
                                "properties.interfaceNameEI === InvoiceConstant.INVOICE_YSHS && properties.interfaceName === InvoiceConstant.INVOICE_YSHS && $checkPermission(['button_ACInvoice_getInvoiceNo'])"
                            }
                          ],
                          attrs: { no: "15", type: "primary" },
                          on: { click: _vm.getInvoiceInfo }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.GetInvoiceNumber")))]
                      ),
                      _vm.$checkPermission([
                        "button_ACInvoice_updateInvoiceType"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "16", type: "primary" },
                              on: { click: _vm.updateInvoiceHandler }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Invoice.invoice_UpdateInvoice"))
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.isBwjsy &&
                                !_vm.isNuoNuo &&
                                _vm.$checkPermission([
                                  "button_ACInvoice_getInvoiceNo"
                                ]),
                              expression:
                                "isBwjsy && !isNuoNuo && $checkPermission(['button_ACInvoice_getInvoiceNo'])"
                            }
                          ],
                          attrs: { no: "17", type: "primary" },
                          on: { click: _vm.getInvoiceNoByBwjsy }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.GetInvoiceNumber")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isBwjsy && !_vm.isNuoNuo,
                              expression: "isBwjsy && !isNuoNuo"
                            }
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.personAuth }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.PersonAuth")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.isHtxx &&
                                !_vm.isNuoNuo &&
                                _vm.$checkPermission([
                                  "button_ACInvoice_getInvoiceNo"
                                ]),
                              expression:
                                "isHtxx && !isNuoNuo && $checkPermission(['button_ACInvoice_getInvoiceNo'])"
                            }
                          ],
                          attrs: { no: "18", type: "primary" },
                          on: { click: _vm.getInvoiceNoByHtxx }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.GetInvoiceNumber")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (_vm.isTaxEasyThreePlus ||
                                  _vm.isNuoNuo ||
                                  _vm.isAisinoEi) &&
                                _vm.$checkPermission([
                                  "button_ACInvoice_getInvoiceNo"
                                ]),
                              expression:
                                "(isTaxEasyThreePlus || isNuoNuo || isAisinoEi) && $checkPermission(['button_ACInvoice_getInvoiceNo'])"
                            }
                          ],
                          attrs: { no: "getInvoiceNoQd", type: "primary" },
                          on: { click: _vm.getInvoiceNoQd }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.GetInvoiceNumber")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showEasyPaperTicketPrint,
                              expression: "showEasyPaperTicketPrint"
                            }
                          ],
                          attrs: { type: "success", no: "19" },
                          on: { click: _vm.taxEasyThreePaperPrint }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.PaperTicketPrinting")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.searchConditions.paymentType === 1 &&
                                _vm.properties.settlementCenterMode,
                              expression:
                                "searchConditions.paymentType === 1 && properties.settlementCenterMode"
                            }
                          ],
                          attrs: { type: "primary", no: "20" },
                          on: { click: _vm.sendSharingCenter }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_SendingSharingCenter")
                            )
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.searchConditions.paymentType === 1 &&
                                _vm.properties.settlementCenterMode,
                              expression:
                                "searchConditions.paymentType === 1 && properties.settlementCenterMode"
                            }
                          ],
                          attrs: { type: "primary", no: "21" },
                          on: { click: _vm.querySendResult }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_GetSendResult")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.properties.isEasyInoivceVietnam &&
                                _vm.$checkPermission([
                                  "button_ACInvoice_getInvoiceNo"
                                ]),
                              expression:
                                "properties.isEasyInoivceVietnam && $checkPermission(['button_ACInvoice_getInvoiceNo'])"
                            }
                          ],
                          attrs: { no: "22", type: "primary" },
                          on: { click: _vm.getInvoiceNoByEasyInvoice }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Invoice.GetInvoiceNumberVietnam"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.properties.isEasyInoivceVietnam &&
                                _vm.$checkPermission([
                                  "button_ACInvoice_getInvoiceNo"
                                ]),
                              expression:
                                "properties.isEasyInoivceVietnam && $checkPermission(['button_ACInvoice_getInvoiceNo'])"
                            }
                          ],
                          attrs: { no: "23", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.getInvoiceNoByEasyInvoice(
                                "checkInvoiceState"
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Invoice.GetInvoiceStateVietnam"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.properties.isEasyInoivceVietnam &&
                                _vm.$checkPermission([
                                  "button_ACInvoice_getInvoiceNo"
                                ]),
                              expression:
                                "properties.isEasyInoivceVietnam && $checkPermission(['button_ACInvoice_getInvoiceNo'])"
                            }
                          ],
                          attrs: { no: "24", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.getInvoiceNoByEasyInvoice(
                                "getInvoicePdf"
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.GetInvoicePdfVietnam")))]
                      ),
                      (_vm.hmToFinanceApi ||
                        _vm.jydToFinanceApi ||
                        _vm.qlToFinanceApi) &&
                      _vm.$checkPermission(["button_ACInvoice_syncCloud"])
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "25" },
                              on: { click: _vm.syncCloudPlatform }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.Cargo_SynchronousCloudPlatform"
                                  )
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.toExoSystemTp &&
                                _vm.$checkPermission([
                                  "button_ACInvoice_exportPillInvoice"
                                ]),
                              expression:
                                "toExoSystemTp && $checkPermission(['button_ACInvoice_exportPillInvoice'])"
                            }
                          ],
                          attrs: { no: "exportPillInvoice", type: "primary" },
                          on: { click: _vm.exportPillInvoiceHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("PillReport.ExportInvoiceData")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.$checkPermission([
                                "button_ACInvoice_previewVoucher"
                              ]),
                              expression:
                                "$checkPermission(['button_ACInvoice_previewVoucher'])"
                            }
                          ],
                          attrs: { no: "previewVoucher", type: "primary" },
                          on: { click: _vm.previewVoucherHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_PreviewVoucher"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.$checkPermission([
                                "button_ACInvoice_exportVoucher"
                              ]),
                              expression:
                                "$checkPermission(['button_ACInvoice_exportVoucher'])"
                            }
                          ],
                          attrs: { no: "exportVoucher", type: "primary" },
                          on: { click: _vm.exportVoucherHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ExportVoucher")))]
                      ),
                      _vm._l(_vm.instructioinBtns, function(item, index) {
                        return [
                          _c(
                            "el-button",
                            {
                              key: "instruction" + index,
                              attrs: {
                                type: "primary",
                                disabled: !item.allowOperate
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onInstructionClick(item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$selectByLang(
                                      item.chineseName,
                                      item.englishName,
                                      item.japaneseName
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      })
                    ],
                    2
                  ),
                  _c("template", { slot: "searchAreaHeader" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "app-main-inner-row extension-conditions-form"
                      },
                      [
                        _c(
                          "el-form",
                          { attrs: { inline: true, "label-position": "left" } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "el-form-item-search",
                                attrs: {
                                  label: _vm.$t(
                                    "Invoice.invoice_revenueAndExpenditureMethod"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { no: "20" },
                                    model: {
                                      value: _vm.searchConditions.paymentType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.searchConditions,
                                          "paymentType",
                                          $$v
                                        )
                                      },
                                      expression: "searchConditions.paymentType"
                                    }
                                  },
                                  [
                                    _vm.$checkPermission([
                                      "button_tabQueryInvoice_allCharge"
                                    ])
                                      ? _c(
                                          "el-radio",
                                          { attrs: { label: -1 } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("Invoice.invoice_all")
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.$checkPermission([
                                      "button_tabQueryInvoice_arCharge"
                                    ])
                                      ? _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Invoice.invoice_receivables"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.$checkPermission([
                                      "button_tabQueryInvoice_apCharge"
                                    ])
                                      ? _c(
                                          "el-radio",
                                          { attrs: { label: 0 } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Invoice.invoice_payables"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.useOrderCenterMode,
                                    expression: "useOrderCenterMode"
                                  }
                                ],
                                staticClass: "el-form-item-search",
                                attrs: { "label-width": "0" }
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { no: "21" },
                                    model: {
                                      value:
                                        _vm.searchConditions.internalCharge,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.searchConditions,
                                          "internalCharge",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "searchConditions.internalCharge"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_InternalCharges")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "el-form-item-search",
                                attrs: {
                                  label: _vm.$t("Invoice.invoice_invoiceDate")
                                }
                              },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 8 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { "label-width": "0" } },
                                          [
                                            _c("el-date-picker", {
                                              attrs: {
                                                no: "22",
                                                type: "date",
                                                clearable: false,
                                                "value-format": "yyyy-MM-dd",
                                                "picker-options":
                                                  _vm.pickerOptions,
                                                editable: false
                                              },
                                              model: {
                                                value:
                                                  _vm.searchConditions
                                                    .inputDateStart,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.searchConditions,
                                                    "inputDateStart",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchConditions.inputDateStart"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c("el-col", { attrs: { span: 2 } }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Invoice.invoice_dateTo")
                                          )
                                        )
                                      ])
                                    ]),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 8 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { "label-width": "0" } },
                                          [
                                            _c("el-date-picker", {
                                              attrs: {
                                                no: "23",
                                                type: "date",
                                                clearable: "",
                                                "value-format": "yyyy-MM-dd",
                                                "picker-options":
                                                  _vm.pickerOptions
                                              },
                                              model: {
                                                value:
                                                  _vm.searchConditions
                                                    .inputDateEnd,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.searchConditions,
                                                    "inputDateEnd",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchConditions.inputDateEnd"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { "label-width": "0" } },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                attrs: { no: "24" },
                                                model: {
                                                  value:
                                                    _vm.allowTwoYearOutside,
                                                  callback: function($$v) {
                                                    _vm.allowTwoYearOutside = $$v
                                                  },
                                                  expression:
                                                    "allowTwoYearOutside"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Invoice.invoice_queryLotsOfData"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid-wrapper", {
                attrs: {
                  "config-module": "190605",
                  "per-config-name": _vm.perConfigName,
                  "refresh-id": _vm.gridRefreshId,
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "sum-column-defs": _vm.sumColumnDefs,
                  "row-data": _vm.rowData,
                  "customs-column-defs": _vm.customsColumnDefs,
                  "show-row-groups": _vm.dataListDragGroup
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "pagination-wrapper",
              attrs: { id: "footer-wrapper" }
            },
            [
              _c(
                "div",
                {
                  class: [_vm.shouldFixed ? "fixedBottom" : ""],
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "flex-wrap": "wrap"
                  }
                },
                [
                  _vm.reCalc
                    ? _c("charge-count-group", {
                        attrs: {
                          "selected-count":
                            _vm.totalAmountToCurrency.selectedCount,
                          "data-provider":
                            _vm.totalAmountToCurrency.dataProvider,
                          "display-and-count-field-list":
                            _vm.totalAmountToCurrency.displayAndCountFieldList,
                          "basic-currency": _vm.localCurrency,
                          "always-show": true,
                          "charge-total-data":
                            _vm.totalAmountToCurrency.chargeTotalData,
                          source: "invoiceQueryList"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.appendQuery,
                      expression: "appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: {
                      total: _vm.searchConditions.total,
                      layout: "total"
                    }
                  })
                ],
                1
              ),
              !_vm.appendQuery
                ? _c("cargo-pagination", {
                    attrs: {
                      "config-module": "190605",
                      total: _vm.searchConditions.total,
                      page: _vm.searchConditions.pageNum,
                      limit: _vm.searchConditions.pageSize
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(_vm.searchConditions, "pageNum", $event)
                      },
                      "update:limit": function($event) {
                        return _vm.$set(
                          _vm.searchConditions,
                          "pageSize",
                          $event
                        )
                      },
                      pagination: _vm.fetchDataByPage
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("invoice-detail-dialog", {
        ref: "makeInvoiceDialog",
        attrs: {
          visible: this.step === "step3",
          title: _vm.$t("Invoice.invoice_invoiceInformation"),
          params: _vm.makeInvoiceDialog.params,
          properties: this.properties,
          location: _vm.location,
          "view-source": "tabInvoiceQuery"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(this, "step === 'step3'", $event)
          },
          toStepHandler: _vm.toStepHandler,
          pageChange: _vm.pageChange,
          saveSuccess: _vm.saveSuccess,
          refresh: _vm.toQueryInvoiceList
        }
      }),
      _c("bill-payment-dialog", {
        ref: "billPayment",
        attrs: { location: _vm.location, visible: _vm.showBillPaymentDialog },
        on: {
          "update:visible": function($event) {
            _vm.showBillPaymentDialog = $event
          },
          cancel: _vm.cancelBillPayment
        }
      }),
      _vm.emailLogTitleWindow.visible
        ? _c("email-log-title-window", {
            ref: "emailLogTitleWindow",
            attrs: {
              visible: _vm.emailLogTitleWindow.visible,
              "invoice-key": _vm.emailLogTitleWindow.invoiceKey || ""
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.emailLogTitleWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.downloadLogWindow.visible
        ? _c("download-log-window", {
            ref: "downloadLogWindow",
            attrs: {
              visible: _vm.downloadLogWindow.visible,
              "fk-uuid": _vm.downloadLogWindow.invoiceKey || ""
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.downloadLogWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.emailEnterTitleWindow.visible
        ? _c("email-enter-title-window", {
            ref: "emailEnterTitleWindow",
            attrs: {
              visible: _vm.emailEnterTitleWindow.visible,
              "invoice-key": _vm.emailEnterTitleWindow.invoiceKey,
              "account-id": _vm.emailEnterTitleWindow.accountId
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.emailEnterTitleWindow, "visible", $event)
              },
              sendEmailSuccess: _vm.sendEmailSuccessHandler
            }
          })
        : _vm._e(),
      _vm.updateInvoice.visible
        ? _c("update-invoice-window", {
            attrs: {
              visible: _vm.updateInvoice.visible,
              "invoice-list": _vm.updateInvoice.invoiceList,
              fei: _vm.isFei
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.updateInvoice, "visible", $event)
              },
              updateSuccess: _vm.updateSuccessHandler
            }
          })
        : _vm._e(),
      _c(
        "cargo-dialog",
        {
          attrs: {
            title: _vm.$t("Invoice.PaperTicketPrinting"),
            visible: _vm.taxEasyThreePrintDialog.visible,
            "can-maximize": true
          },
          on: {
            close: function($event) {
              _vm.taxEasyThreePrintDialog.visible = false
            }
          }
        },
        [
          _c("iframe", {
            staticStyle: {
              width: "100%",
              height: "100%",
              "min-height": "600px",
              border: "none"
            },
            attrs: { src: _vm.taxEasyThreePrintDialog.url }
          })
        ]
      ),
      _vm.customizeRevokeInvoiceAutoCharge === 2 && _vm.batchRedFlush.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.batchRedFlush.visible,
                title: _vm.$t("Clearing.RedPunchInvoice"),
                width: "410px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.batchRedFlush, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c("el-form-item", { attrs: { "label-width": "0" } }, [
                        _c("div", {
                          staticClass: "el-message-box__status el-icon-warning",
                          staticStyle: { "font-size": "20px !important" }
                        }),
                        _c("div", { staticClass: "el-message-box__message" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "Invoice.BatchCheckRedFlushInvoiceTipOne"
                                )
                              ) +
                              " "
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                color: "red",
                                "font-size": "18px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.batchRedFlush.invoiceKeys.length)
                              )
                            ]
                          ),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "Invoice.BatchCheckRedFlushInvoiceTipTwo"
                                )
                              ) +
                              " "
                          )
                        ])
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "Invoice.SelectReasonForRedOffsetInvoice"
                            )
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "250px" },
                              attrs: { clearable: false },
                              model: {
                                value: _vm.batchRedFlush.redOffsetReason,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.batchRedFlush,
                                    "redOffsetReason",
                                    $$v
                                  )
                                },
                                expression: "batchRedFlush.redOffsetReason"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("Invoice.IncorrectInvoicing"),
                                  value: "01"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("Invoice.ServiceTermination"),
                                  value: "03"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("Invoice.SalesAllowance"),
                                  value: "04"
                                }
                              }),
                              _vm.showSalesReturn
                                ? _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Invoice.SalesReturn"),
                                      value: "02"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("div", { staticStyle: { "line-height": "24px" } }, [
                        _c("i", {
                          staticClass: "el-icon-question",
                          staticStyle: { "font-size": "18px", color: "black" }
                        }),
                        _c("br"),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Clearing.BatchCheckRedFlushInvoiceMessageOne"
                              )
                            )
                          )
                        ]),
                        _c("br"),
                        _vm.properties.interfaceNameEI ===
                        _vm.InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Clearing.BatchCheckRedFlushInvoiceMessageTwo"
                                  )
                                )
                              )
                            ])
                          : _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Clearing.BatchCheckRedFlushInvoiceMessageThree"
                                  )
                                )
                              )
                            ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "confirm", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.confirmRedPunch()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "cancel" },
                      on: {
                        click: function($event) {
                          _vm.batchRedFlush.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.customizeRevokeInvoiceAutoCharge !== 2 && _vm.batchRedFlush.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.batchRedFlush.visible,
                title: _vm.$t("Message.Prompt"),
                width: "550px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.batchRedFlush, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "75px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("el-form-item", { attrs: { "label-width": "0" } }, [
                        _c("div", {
                          staticClass: "el-message-box__status el-icon-warning"
                        }),
                        _c("div", { staticClass: "el-message-box__message" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                this.$t(
                                  "Invoice.BatchCheckRedFlushInvoiceTipOne"
                                )
                              ) +
                              " "
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                color: "red",
                                "font-size": "18px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.batchRedFlush.invoiceKeys.length)
                              )
                            ]
                          ),
                          _vm._v(
                            " " +
                              _vm._s(
                                this.$t(
                                  "Invoice.BatchCheckRedFlushInvoiceTipTwo"
                                ) + _vm.batchRedFlush.message
                              ) +
                              " "
                          )
                        ])
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Invoice.RedFlushReason"),
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.batchRedFlush.redOffsetReason,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.batchRedFlush,
                                    "redOffsetReason",
                                    $$v
                                  )
                                },
                                expression: "batchRedFlush.redOffsetReason"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: "01" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("Invoice.IncorrectInvoicing"))
                                )
                              ]),
                              _c("el-radio", { attrs: { label: "02" } }, [
                                _vm._v(_vm._s(_vm.$t("Invoice.SalesReturn")))
                              ]),
                              _c("el-radio", { attrs: { label: "03" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("Invoice.ServiceTermination"))
                                )
                              ]),
                              _c("el-radio", { attrs: { label: "04" } }, [
                                _vm._v(_vm._s(_vm.$t("Invoice.SalesAllowance")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "confirm", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.confirmRedPunch()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "cancel" },
                      on: {
                        click: function($event) {
                          _vm.batchRedFlush.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.batchRedPunchDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.batchRedPunchDialog.visible,
                title: _vm.$t("Clearing.RedPunchInvoice"),
                width: "410px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.batchRedPunchDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c("el-form-item", { attrs: { "label-width": "0" } }, [
                        _c("div", {
                          staticClass: "el-message-box__status el-icon-warning",
                          staticStyle: { "font-size": "20px !important" }
                        }),
                        _c("div", { staticClass: "el-message-box__message" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "Invoice.BatchCheckRedFlushInvoiceTipOne"
                                )
                              ) +
                              " "
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                color: "red",
                                "font-size": "18px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.batchRedPunchDialog.invoiceKeys.length
                                )
                              )
                            ]
                          ),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "Invoice.BatchCheckRedFlushInvoiceTipTwo"
                                )
                              ) +
                              " "
                          )
                        ])
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "Invoice.SelectReasonForRedOffsetInvoice"
                            )
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "250px" },
                              attrs: { clearable: false },
                              model: {
                                value: _vm.batchRedPunchDialog.redOffsetReason,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.batchRedPunchDialog,
                                    "redOffsetReason",
                                    $$v
                                  )
                                },
                                expression:
                                  "batchRedPunchDialog.redOffsetReason"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "Clearing.IncorrectInvoiceInformation"
                                  ),
                                  value: "InvoiceError"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "Clearing.IncorrectChargeInformation"
                                  ),
                                  value: "ChargeError"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("div", { staticStyle: { "line-height": "24px" } }, [
                        _c("i", {
                          staticClass: "el-icon-question",
                          staticStyle: { "font-size": "18px", color: "black" }
                        }),
                        _c("br"),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Clearing.BatchCheckRedPunchInvoiceMessageOne"
                              )
                            )
                          )
                        ]),
                        _c("br"),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Clearing.BatchCheckRedPunchInvoiceMessageTwo"
                              )
                            )
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "confirm", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.doRedPunchInvoices()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "cancel" },
                      on: {
                        click: function($event) {
                          _vm.batchRedPunchDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.ewmDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.ewmDialog.visible,
                title: _vm.$t("Message.Prompt"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.ewmDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "75px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("el-form-item", { attrs: { "label-width": "0" } }, [
                        _c("div", {
                          staticClass: "el-message-box__status el-icon-warning"
                        }),
                        _c("div", { staticClass: "el-message-box__message" }, [
                          _vm._v(
                            " " +
                              _vm._s(this.$t("Invoice.WeChatScanningAgain")) +
                              " "
                          )
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "0 auto",
                            width: "fit-content"
                          }
                        },
                        [
                          _c("qr", {
                            staticClass: "vue-qr",
                            attrs: {
                              text: _vm.ewmDialog.ewm,
                              "logo-scale": 200,
                              size: 200
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "Certified",
                        type: "primary",
                        disabled: !!_vm.ewmDialog.time
                      },
                      on: {
                        click: function($event) {
                          return _vm.realPersonAuthentication(true)
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.ewmDialog.time
                            ? _vm.$t("Invoice.Certified") +
                                "(" +
                                _vm.ewmDialog.time +
                                ")"
                            : _vm.$t("Invoice.Certified")
                        )
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.pushLogDialog.visible && !_vm.qlToFinanceApi
        ? _c("push-log-dialog", {
            attrs: {
              visible: _vm.pushLogDialog.visible,
              uuid: _vm.pushLogDialog.uuid
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.pushLogDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.pushLogDialog.visible && _vm.qlToFinanceApi
        ? _c("push-log-dialog-ql", {
            attrs: {
              visible: _vm.pushLogDialog.visible,
              uuid: _vm.pushLogDialog.uuid
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.pushLogDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.workFlowApplyDialog.visible
        ? _c("invoice-work-flow-apply-dialog", {
            ref: "workFlowApplyDialog",
            attrs: {
              "is-bpm": true,
              "process-info": _vm.workFlowApplyDialog.documentProcess,
              records: _vm.workFlowApplyDialog.approvalCommentsRecords,
              type: "approve",
              visible: _vm.workFlowApplyDialog.visible,
              title: _vm.$t("Invoice.invoice_invoiceInformation"),
              properties: _vm.workFlowApplyDialog.invoiceProperties,
              "view-source": "tabInvoiceQuery"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.workFlowApplyDialog, "visible", $event)
              },
              pageChange: _vm.pageChange,
              close: function($event) {
                _vm.workFlowApplyDialog.visible = false
              },
              closeAndRefresh: function() {
                _vm.workFlowApplyDialog.visible = false
                _vm.fetchDataByPage()
              }
            }
          })
        : _vm._e(),
      _vm.accountingEntryWindow.visible
        ? _c("accounting-entry-window", {
            attrs: {
              visible: _vm.accountingEntryWindow.visible,
              "is-ext": _vm.accountingEntryWindow.isExt,
              "prefix-data-provider":
                _vm.accountingEntryWindow.prefixDataProvider,
              "account-title-data-provider":
                _vm.accountingEntryWindow.accountTitleDataProvider,
              "mapping-departments":
                _vm.accountingEntryWindow.mappingDepartments,
              "mapping-staffs": _vm.accountingEntryWindow.mappingStaffs,
              voucher: _vm.accountingEntryWindow.rowData,
              index: _vm.accountingEntryWindow.index,
              "account-set": _vm.accountingEntryWindow.accountSet,
              check: false,
              "check-department": false,
              preview: true
            },
            on: {
              close: function() {
                return (_vm.accountingEntryWindow.visible = false)
              },
              updateAudit: function($event) {
                return _vm.toQueryInvoiceList()
              }
            }
          })
        : _vm._e(),
      _c("merge-invoice-file-window", { ref: "mergeInvoiceFileWindow" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }